import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-untracked",
  "use": "icon-untracked-usage",
  "viewBox": "0 0 18.51 17.61",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.51 17.61\" id=\"icon-untracked\"><defs><style>#icon-untracked .cls-1{fill:none;stroke:#0df;stroke-miterlimit:10;}</style></defs><g id=\"icon-untracked_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-untracked_圖層_1-2\" data-name=\"圖層 1\"><polygon class=\"cls-1\" points=\"9.26 1.13 11.78 6.25 17.44 7.07 13.35 11.06 14.31 16.69 9.26 14.03 4.2 16.69 5.16 11.06 1.07 7.07 6.73 6.25 9.26 1.13\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol